import React, { useEffect, useMemo, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Store } from "../../flux";
import { refreshChartThemes } from "../../utils/chartTheme";

export const createAppTheme = (mode) => {
  const dark = mode === "dark";
  return createTheme({
    palette: {
      mode,
      primary: { main: dark ? "#6fd9e6" : "#1d8290", contrastText: dark ? "#102a33" : "#ffffff" },
      secondary: { main: dark ? "#b9a8ef" : "#6879c7" },
      success: { main: dark ? "#7fe0ae" : "#137a56" },
      warning: { main: dark ? "#ffd18c" : "#9a6410" },
      error: { main: dark ? "#ff9dad" : "#b83d53" },
      info: { main: dark ? "#99ccff" : "#176c9c" },
      background: { default: dark ? "#0f1720" : "#f4f7f8", paper: dark ? "#182431" : "#ffffff" },
      text: { primary: dark ? "#e6edf3" : "#23364d", secondary: dark ? "#9fb0bd" : "#526477" },
      divider: dark ? "#314657" : "#e5ebef",
      action: { hover: dark ? "rgba(111, 217, 230, .08)" : "rgba(38, 166, 183, .06)", selected: dark ? "rgba(111, 217, 230, .16)" : "rgba(38, 166, 183, .12)" },
    },
    typography: { fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
    shape: { borderRadius: 10 },
    components: {
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            "--DataGrid-containerBackground": dark ? "#1e2c3a" : "#f8fafb",
            "--DataGrid-pinnedBackground": dark ? "#182431" : "#ffffff",
            borderColor: dark ? "#314657" : "#e5ebef",
          },
        },
      },
    },
  });
};

export default function AppThemeProvider({ children }) {
  const [mode, setMode] = useState(Store.getTheme());
  useEffect(() => {
    const onChange = () => setMode(Store.getTheme());
    Store.addChangeListener(onChange);
    return () => Store.removeChangeListener(onChange);
  }, []);
  useEffect(() => { refreshChartThemes(); }, [mode]);
  const theme = useMemo(() => createAppTheme(mode), [mode]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
